import React from "react";
import SearchAnalyticsDashboard from "./SearchAnalyticsDashboard";
import SEO from "./SEO";

function AdminSearchAnalytics() {
  return (
    <div className="min-h-screen bg-gray-50">
      <SEO
        title="Search Analytics - One80Labs Admin"
        description="Search analytics and insights for One80Labs content."
        noindex={true}
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Search Analytics</h1>
          <p className="mt-2 text-gray-600">
            Monitor search behavior, track popular queries, and analyze search
            performance.
          </p>
        </div>

        {/* Search Analytics Dashboard */}
        <SearchAnalyticsDashboard className="mb-8" />

        {/* Additional Insights */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Quick Actions */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Quick Actions
            </h3>
            <div className="space-y-3">
              <button
                onClick={() => {
                  // Export search analytics
                  const analytics = JSON.parse(
                    localStorage.getItem("searchAnalytics") || "[]",
                  );
                  const dataStr = JSON.stringify(analytics, null, 2);
                  const dataBlob = new Blob([dataStr], {
                    type: "application/json",
                  });
                  const url = URL.createObjectURL(dataBlob);
                  const link = document.createElement("a");
                  link.href = url;
                  link.download = "search-analytics.json";
                  link.click();
                }}
                className="w-full flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#F98B3D]"
              >
                Export Analytics Data
              </button>
              <button
                onClick={() => {
                  if (
                    window.confirm(
                      "Are you sure you want to clear all search analytics? This action cannot be undone.",
                    )
                  ) {
                    localStorage.removeItem("searchAnalytics");
                    localStorage.removeItem("searchHistory");
                    window.location.reload();
                  }
                }}
                className="w-full flex items-center justify-center px-4 py-2 border border-red-300 rounded-md shadow-sm text-sm font-medium text-red-700 bg-white hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
              >
                Clear All Analytics
              </button>
            </div>
          </div>

          {/* Search Tips */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Search Optimization Tips
            </h3>
            <div className="space-y-3 text-sm text-gray-600">
              <div className="flex items-start">
                <span className="flex-shrink-0 w-2 h-2 bg-[#F98B3D] rounded-full mt-2 mr-3"></span>
                <p>
                  Monitor popular searches to identify content gaps and
                  opportunities
                </p>
              </div>
              <div className="flex items-start">
                <span className="flex-shrink-0 w-2 h-2 bg-[#F98B3D] rounded-full mt-2 mr-3"></span>
                <p>
                  Use search time metrics to optimize database queries and
                  indexes
                </p>
              </div>
              <div className="flex items-start">
                <span className="flex-shrink-0 w-2 h-2 bg-[#F98B3D] rounded-full mt-2 mr-3"></span>
                <p>
                  Track clicked results to understand what content users find
                  most relevant
                </p>
              </div>
              <div className="flex items-start">
                <span className="flex-shrink-0 w-2 h-2 bg-[#F98B3D] rounded-full mt-2 mr-3"></span>
                <p>
                  Analyze search patterns to improve content tagging and
                  categorization
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminSearchAnalytics;
